import React, { createContext, useReducer } from "react";

export const UPDATE_STATE = "UPDATE_STATE";

const initialState = {
  userName: null,
  userid: null,
  userEmail: null,
  is_Organizer: null,
  userempid: null,
  projectId: null,
  userRoles: [],
  userEvents: null,
  CurrentEvent: null,
  isLoggedIn: false,
  isLoggingIn: true, 
};

const reducer = (state, action) => {
  switch (action?.type) {
    case UPDATE_STATE:
      return action?.payload ? { ...state, ...action.payload } : state;
    default:
      return state;
  }
};

export const AppContext = createContext(initialState);

export const AppContextProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <AppContext.Provider value={[state, dispatch]}>
      {props.children}
    </AppContext.Provider>
  );
};
